import { render } from "./AdditionalServices.vue?vue&type=template&id=cf982212&scoped=true"
import script from "./AdditionalServices.vue?vue&type=script&lang=js"
export * from "./AdditionalServices.vue?vue&type=script&lang=js"

import "./AdditionalServices.vue?vue&type=style&index=0&id=cf982212&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf982212"]])

export default __exports__